var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "stats" },
    _vm._l(_vm.data, function (stats, index) {
      return _c("b-col", { key: index }, [
        _c("span", [_vm._v(_vm._s(stats.title))]),
        _vm._v(" "),
        _c("span", { style: { color: stats.color } }, [
          _vm._v(_vm._s(stats.value)),
        ]),
      ])
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }